'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cookie = require('cookie');

var CookieStorage = function () {
  function CookieStorage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CookieStorage);

    this.options = options;
  }

  // eslint-disable-next-line class-methods-use-this


  _createClass(CookieStorage, [{
    key: 'getItem',
    value: function getItem(key) {
      var str = document.cookie;
      var obj = cookie.parse(str);
      return obj[key];
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      document.cookie = cookie.serialize(key, value, {
        // @NOTE: The cookies last the duration of the user’s "session",
        // to add a longer cookie expiration, do like so:
        // CookieStorage({ expires: new Date(2020, 1, 1) })
        expires: this.options.expires,
        maxAge: this.options.maxAge,
        path: this.options.path || '/'
      });
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      document.cookie = cookie.serialize(key, '', { expires: new Date(0) });
    }
  }]);

  return CookieStorage;
}();

module.exports = CookieStorage;